import { render, staticRenderFns } from "./OmdService.vue?vue&type=template&id=a566803e&scoped=true"
var script = {}
import style0 from "./OmdService.vue?vue&type=style&index=0&id=a566803e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a566803e",
  null
  
)

export default component.exports